import React from "react";

const SocialForBlogs = () => {
  return (
    <>
      {/* <!--Social Icon--> */}
      <a
        className="ptf-social-icon ptf-social-icon--style-4 facebook"
        // href="https://www.facebook.com/multicloudai"
        href="#"
      >
        <i className="socicon-facebook"></i>
      </a>
      {/* <!--Social Icon--> */}
      <a
        className="ptf-social-icon ptf-social-icon--style-4 twitter"
        // href="https://twitter.com/multicloudai"
        href="#"
      >
        <i className="socicon-twitter"></i>
      </a>
      {/* <!--Social Icon--> */}
      <a
        className="ptf-social-icon ptf-social-icon--style-4 instagram"
        // href="https://www.instagram.com/multicloudai"
        href="#"
      >
        <i className="socicon-instagram"></i>
      </a>
      {/* <!--Social Icon--> */}
      <a
        className="ptf-social-icon ptf-social-icon--style-4 linkedin"
        // href="https://linkedin.com/company/multicloudai/"
        href="#"
      >
        <i className="socicon-linkedin"></i>
      </a>
    </>
  );
};

export default SocialForBlogs;
